import ZoomInIcon from '@/components/Icons/ZoomInIcon';
import { EntityType } from '@/domain/entities';
import type { File } from '@/domain/files';
import { type FC } from 'react';

interface Props {
  images: File[];
  setSelectedImageIndex: (imageIndex: number) => void;
}

const CommunityPhotosGrid: FC<Props> = ({ images, setSelectedImageIndex }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {images.map((image, imageIndex) => (
        <div
          key={image.id}
          className="relative aspect-[4/3] overflow-hidden rounded-none border border-gray-200 hover:border-gray-300 transition-colors duration-300 cursor-pointer group"
          onClick={() => setSelectedImageIndex(imageIndex)}
        >
          <img
            src={image.url}
            alt={image.description}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <h3 className="text-white font-semibold text-lg">{image.description}</h3>
              <p className="text-gray-200 text-sm capitalize">
                {
                  image.fileEntities?.find((entity) => entity.entityType === EntityType.COMMUNITY)
                    ?.metadata?.category
                }
              </p>
            </div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <ZoomInIcon />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommunityPhotosGrid;
